import { trpc } from '~/trpc/client';
import { type GetSearchResponse } from '~/trpc/routers/search-router';

type UseSearchResultsQueryParams = {
  phrase: string;
  sort?: string;
  facets?: Record<string, string[]>;
  pageSize?: number;
};

export const useSearchResultsQuery = (
  params: UseSearchResultsQueryParams,
  initialData: GetSearchResponse,
) => {
  const { phrase, sort, facets, pageSize = 20 } = params;

  return trpc.search.searchProducts.useInfiniteQuery(
    {
      phrase,
      facets,
      limit: pageSize,
      sort,
    },
    {
      staleTime: 1000 * 60 * 3, // 3 mins // stop existing data being refetched as soon as page is loaded and keep in memory for loger on navigation
      getNextPageParam: (lastPage) => {
        return lastPage?.nextCursor ?? null;
      },
      initialCursor: 0,
      initialData: {
        pages: [initialData],
        pageParams: [0],
      },
    },
  );
};
